import styled from "styled-components"
import {H5} from "@irati/ui/src//Typography/Heading"
import multiLineEllipsis from "@irati/ui/src/global/css/multiLineEllipsis"
import IconButton from "../styled/IconButton"

const LINES_TO_SHOW = 3
const LINE_HEIGHT = 21

export const StyledH5 = styled(H5)`
  display: inline-block;
  ${multiLineEllipsis(LINES_TO_SHOW, LINE_HEIGHT)}
  height: auto;
  max-height : ${(LINES_TO_SHOW * LINE_HEIGHT)}px;
`

export const StyledIconBtn = styled(IconButton)`
  padding: 10px;
`
